import { Text } from "@carbon6/c6-frontend-design";
import type { ReactNode } from "react";
import type { Embodiment } from "@/api";
import { hatcheryTextModes } from "@/app/theme";
import { formatEndEffector } from "./embodimentDisplay";
import styles from "./EmbodimentDetailContent.module.css";

export type EmbodimentDetailContentProps = {
  embodiment: Embodiment;
  // 감싸는 컨테이너가 이미 여백을 주는 경우(예: 선택 모달 미리보기)에는 본문 자체 패딩을 없앤다.
  flush?: boolean;
};

// Embodiment 읽기 전용 상세 본문이다. 설명과 End Effector를 항목·값 두 열로 표시한다.
// 다음 세 곳이 이 본문을 공유한다:
//   - Embodiment 페이지의 상세 모달(EmbodimentDetailModal)
//   - 데이터셋 리뷰 탭 `Embodiment` 카드의 인라인 상세
//   - 선택 모달(EmbodimentSourceChoiceDialog)의 미리보기
// 세 곳 모두 바로 위에 대상 이름이나 축 이름이 있다. 그래서 본문은 제목을 표시하지 않는다.
// 모달 셸·패널 같은 컨테이너는 소비처가 소유하고, 여기는 본문만 그린다.
export function EmbodimentDetailContent({
  embodiment,
  flush = false,
}: EmbodimentDetailContentProps): ReactNode {
  return (
    <div className={flush ? `${styles.body} ${styles.flush}` : styles.body}>
      <table className={styles.specs} aria-label="Embodiment 정보">
        <tbody>
          <Spec label="설명" value={embodiment.description?.trim() || "-"} />
          <Spec label="End Effector" value={formatEndEffector(embodiment.end_effector)} />
        </tbody>
      </table>
    </div>
  );
}

function Spec({ label, value }: { label: string; value: string }): ReactNode {
  return (
    <tr>
      <th scope="row" className={styles.specLabel}>
        <Text variant={hatcheryTextModes["caption-normal"]}>{label}</Text>
      </th>
      <td className={styles.specValue}>
        <Text variant={hatcheryTextModes["body-normal"]}>{value}</Text>
      </td>
    </tr>
  );
}
